















import { defineComponent, ref } from '@nuxtjs/composition-api';

import BaseIcon from '../BaseIcon/BaseIcon.vue';
import BaseRadio from '../BaseRadio/BaseRadio.vue';

export default defineComponent({
  name: 'BaseAddress',
  components: {
    BaseRadio,
    BaseIcon,
  },
  inject: ['getSelectedValue', 'setSelectedValue'],
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const selected = ref(props.name);

    return {
      selected,
    };
  },
});
